import React from 'react';
import { Flex } from '@chakra-ui/layout';
import { ProductFeatures } from './ProductFeatures';
import { ProductSpecs } from './ProductSpecs';
import { Title } from './Title';
import YouTube from 'react-youtube';
import { Code } from './Code';
import { useBreakpointValue } from '@chakra-ui/media-query';

interface Props {
  title: string;
  code: string;
  videoId?: string;
  features: string[];
  specs: string[];
  first?: boolean;
  last?: boolean;
}

export const ProductDetail = React.memo(
  ({ title, code, videoId, features, specs, first, last }: Props) => {
    const videoHeight = useBreakpointValue({
      base: '200',
      sm: '350',
      md: '255',
    });

    return (
      <Flex
        width="100%"
        flexDirection="column"
        flex={1}
        pl={{ base: 4, sm: 8 }}
        pr={{ base: 4, sm: 8 }}
        pt={first ? { base: 4, sm: 8 } : 0}
        pb={last ? { base: 4, sm: 8 } : 0}
      >
        <Title>{title}</Title>
        <Code>{code}</Code>
        {videoId && (
          <YouTube
            videoId={videoId}
            opts={{ width: '100%', height: videoHeight }}
          />
        )}
        <ProductFeatures items={features} />
        <ProductSpecs items={specs} />
      </Flex>
    );
  },
);
